import React, { Fragment } from 'react';
import { object, string, bool } from 'prop-types';

import { ListItem } from './listItem';
import {
  Title,
  Wrapper,
} from './styles';


export const EditableList = ({
  items, listTitle, settingsType, keyPrefix, ...props
}) => (
  <Fragment>
    <Title>{listTitle}</Title>
    <Wrapper>
      {Object.keys(items).map(type => (
        <ListItem
          {...props}
          id={items[type]._id}
          title={items[type].title}
          description={items[type].description}
          color={items[type].color}
          isDefault={items[type].isDefault}
          isNew={false}
          key={`${keyPrefix}-${items[type].title}`}
          settingsType={settingsType}
        />
      ))}
      { props.editable &&
      <ListItem
        isNew
        {...props}
        key={`${keyPrefix}-new`}
        settingsType={settingsType}
      /> }
    </Wrapper>
  </Fragment>
);

EditableList.propTypes = {
  items: object,
  listTitle: string.isRequired,
  keyPrefix: string.isRequired,
  settingsType: string.isRequired,
  editable: bool,
};

EditableList.defaultProps = {
  items: {},
  editable: false,
};



// WEBPACK FOOTER //
// ./src/components/editable-list/index.js